import { useHasPermission } from "../auth/useClaims";

// Stock Management module (LPO/Stock-In/Stock-Out/Return/Adjustment/
// Balance) - standard fine-grained permission codes, no all-branch check
// anywhere (server already branch-scopes reads/writes, same as
// Customers/Products/Employees/Vehicles).
export const useCanCreateLpo = () => useHasPermission("Stock.CreateLpo");
export const useCanEditLpo = () => useHasPermission("Stock.EditLpo");
// Additional, individually-assigned permission (Batch98) required on top of
// Stock.EditLpo to edit an LPO that is already APPROVED - meant for 1-2
// named users only, never a role default. Same shape as
// Stock.CreateDirectStockIn's escalation-on-top-of-a-base-permission.
export const useCanEditApprovedLpo = () => useHasPermission("Stock.EditApprovedLpo");
export const useCanViewLpo = () => useHasPermission("Stock.ViewLpo");
export const useCanApproveLpo = () => useHasPermission("Stock.ApproveLpo");
export const useCanCancelLpo = () => useHasPermission("Stock.CancelLpo");
export const useCanPrintLpo = () => useHasPermission("Stock.PrintLpo");

export const useCanCreateStockIn = () => useHasPermission("Stock.CreateStockIn");
// Only required, additionally, for a direct/no-LPO Stock-In - kept separate
// so it can't be used as a silent bypass of the LPO approval gate.
export const useCanCreateDirectStockIn = () => useHasPermission("Stock.CreateDirectStockIn");
export const useCanViewStockIn = () => useHasPermission("Stock.ViewStockIn");
export const useCanPrintStockIn = () => useHasPermission("Stock.PrintStockIn");
export const useCanDeleteStockIn = () => useHasPermission("Stock.DeleteStockIn");

export const useCanCreateStockOut = () => useHasPermission("Stock.CreateStockOut");
export const useCanViewStockOut = () => useHasPermission("Stock.ViewStockOut");
export const useCanPrintStockOut = () => useHasPermission("Stock.PrintStockOut");
export const useCanDeleteStockOut = () => useHasPermission("Stock.DeleteStockOut");

export const useCanCreateReturn = () => useHasPermission("Stock.CreateReturn");
export const useCanViewReturn = () => useHasPermission("Stock.ViewReturn");
export const useCanPrintReturn = () => useHasPermission("Stock.PrintReturn");
export const useCanDeleteReturn = () => useHasPermission("Stock.DeleteReturn");

export const useCanCreateAdjustment = () => useHasPermission("Stock.CreateAdjustment");
export const useCanApproveAdjustment = () => useHasPermission("Stock.ApproveAdjustment");
export const useCanViewAdjustment = () => useHasPermission("Stock.ViewAdjustment");
export const useCanDeleteAdjustment = () => useHasPermission("Stock.DeleteAdjustment");

export const useCanViewBalance = () => useHasPermission("Stock.ViewBalance");

// Dedicated permission under the REPORTS module (Batch66), not
// Stock.ViewBalance/etc - view-only report, no matching .Edit/.Create
// counterpart, same shape as Tax's view-only permission.
export const useCanViewStockMovementReport = () => useHasPermission("Reports.StockMovement");
